"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require("./strings"),
    isValidFloatingPointNumber = _require.isValidFloatingPointNumber,
    isValidSimpleColor = _require.isValidSimpleColor,
    parseFloatingPointNumber = _require.parseFloatingPointNumber,
    stripLeadingAndTrailingASCIIWhitespace = _require.stripLeadingAndTrailingASCIIWhitespace,
    stripNewlines = _require.stripNewlines,
    splitOnCommas = _require.splitOnCommas;

var _require2 = require("./dates-and-times"),
    isValidDateString = _require2.isValidDateString,
    isValidMonthString = _require2.isValidMonthString,
    isValidTimeString = _require2.isValidTimeString,
    isValidWeekString = _require2.isValidWeekString,
    parseLocalDateAndTimeString = _require2.parseLocalDateAndTimeString,
    serializeNormalizedDateAndTime = _require2.serializeNormalizedDateAndTime;

var whatwgURL = require("whatwg-url");

var NodeList = require("../generated/NodeList");

var _require3 = require("../helpers/internal-constants"),
    domSymbolTree = _require3.domSymbolTree;

var NODE_TYPE = require("../node-type");

var submittableLocalNames = new Set(["button", "input", "keygen", "object", "select", "textarea"]);

exports.isDisabled = function (formControl) {
  if (formControl.localName === "button" || formControl.localName === "input" || formControl.localName === "select" || formControl.localName === "textarea") {
    if (formControl.hasAttribute("disabled")) {
      return true;
    }
  }

  var e = formControl.parentNode;

  while (e) {
    if (e.localName === "fieldset" && e.hasAttribute("disabled")) {
      var firstLegendElementChild = e.querySelector("legend");

      if (!firstLegendElementChild || !firstLegendElementChild.contains(formControl)) {
        return true;
      }
    }

    e = e.parentNode;
  }

  return false;
};

exports.isSubmittable = function (formControl) {
  // https://html.spec.whatwg.org/multipage/forms.html#category-submit
  return submittableLocalNames.has(formControl.localName);
};

exports.isButton = function (formControl) {
  // https://html.spec.whatwg.org/multipage/forms.html#concept-button
  return formControl.type === "button" || formControl.type === "submit" || formControl.type === "reset" || formControl.type === "image" || formControl.localName === "button";
};

exports.normalizeToCRLF = function (string) {
  return string.replace(/\r([^\n])/g, "\r\n$1").replace(/\r$/, "\r\n").replace(/([^\r])\n/g, "$1\r\n").replace(/^\n/, "\r\n");
};

exports.isLabelable = function (node) {
  // labelable logic defined at: https://html.spec.whatwg.org/multipage/forms.html#category-label
  if (node.nodeType !== NODE_TYPE.ELEMENT_NODE) {
    return false;
  }

  switch (node.tagName) {
    case "BUTTON":
    case "METER":
    case "OUTPUT":
    case "PROGRESS":
    case "SELECT":
    case "TEXTAREA":
      return true;

    case "INPUT":
      return node.type !== "hidden";
  }

  return false;
};

exports.getLabelsForLabelable = function (labelable) {
  if (!exports.isLabelable(labelable)) {
    return null;
  }

  if (!labelable._labels) {
    var root = labelable.getRootNode();
    labelable._labels = NodeList.create([], {
      element: root,
      query: function query() {
        var nodes = [];

        var _iterator = _createForOfIteratorHelper(domSymbolTree.treeIterator(root)),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var descendant = _step.value;

            if (descendant.control === labelable) {
              nodes.push(descendant);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return nodes;
      }
    });
  }

  return labelable._labels;
}; // https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address


exports.isValidEmailAddress = function (emailAddress) {
  var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var emailAddressRegExp = new RegExp("^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9]" + "(?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}" + "[a-zA-Z0-9])?)*$"); // A valid e-mail address list is a set of comma-separated tokens, where each token is itself
  // a valid e - mail address.To obtain the list of tokens from a valid e - mail address list,
  // an implementation must split the string on commas.

  if (multiple) {
    return splitOnCommas(emailAddress).every(function (value) {
      return emailAddressRegExp.test(value);
    });
  }

  return emailAddressRegExp.test(emailAddress);
};

exports.isValidAbsoluteURL = function (url) {
  return whatwgURL.parseURL(url) !== null;
};

exports.sanitizeValueByType = function (input, val) {
  switch (input.type.toLowerCase()) {
    case "password":
    case "search":
    case "tel":
    case "text":
      val = stripNewlines(val);
      break;

    case "color":
      // https://html.spec.whatwg.org/multipage/forms.html#color-state-(type=color):value-sanitization-algorithm
      val = isValidSimpleColor(val) ? val.toLowerCase() : "#000000";
      break;

    case "date":
      // https://html.spec.whatwg.org/multipage/input.html#date-state-(type=date):value-sanitization-algorithm
      if (!isValidDateString(val)) {
        val = "";
      }

      break;

    case "datetime-local":
      {
        // https://html.spec.whatwg.org/multipage/input.html#local-date-and-time-state-(type=datetime-local):value-sanitization-algorithm
        var dateAndTime = parseLocalDateAndTimeString(val);
        val = dateAndTime !== null ? serializeNormalizedDateAndTime(dateAndTime) : "";
        break;
      }

    case "email":
      // https://html.spec.whatwg.org/multipage/forms.html#e-mail-state-(type=email):value-sanitization-algorithm
      // https://html.spec.whatwg.org/multipage/forms.html#e-mail-state-(type=email):value-sanitization-algorithm-2
      if (input.hasAttribute("multiple")) {
        val = val.split(",").map(function (token) {
          return stripLeadingAndTrailingASCIIWhitespace(token);
        }).join(",");
      } else {
        val = stripNewlines(val);
        val = stripLeadingAndTrailingASCIIWhitespace(val);
      }

      break;

    case "month":
      // https://html.spec.whatwg.org/multipage/input.html#month-state-(type=month):value-sanitization-algorithm
      if (!isValidMonthString(val)) {
        val = "";
      }

      break;

    case "number":
      // https://html.spec.whatwg.org/multipage/input.html#number-state-(type=number):value-sanitization-algorithm
      // TODO: using parseFloatingPointNumber in addition to isValidFloatingPointNumber to pass number.html WPT.
      // Possible spec bug.
      if (!isValidFloatingPointNumber(val) || isNaN(parseFloatingPointNumber(val))) {
        val = "";
      }

      break;

    case "range":
      // https://html.spec.whatwg.org/multipage/input.html#range-state-(type=range):value-sanitization-algorithm
      // TODO: using parseFloatingPointNumber in addition to isValidFloatingPointNumber to pass number.html WPT.
      // Possible spec bug.
      if (!isValidFloatingPointNumber(val) || isNaN(parseFloatingPointNumber(val))) {
        var minimum = input._minimum;
        var maximum = input._maximum;
        var defaultValue = maximum < minimum ? minimum : (minimum + maximum) / 2;
        val = "".concat(defaultValue);
      }

      break;

    case "time":
      // https://html.spec.whatwg.org/multipage/input.html#time-state-(type=time):value-sanitization-algorithm
      if (!isValidTimeString(val)) {
        val = "";
      }

      break;

    case "url":
      // https://html.spec.whatwg.org/multipage/forms.html#url-state-(type=url):value-sanitization-algorithm
      val = stripNewlines(val);
      val = stripLeadingAndTrailingASCIIWhitespace(val);
      break;

    case "week":
      // https://html.spec.whatwg.org/multipage/input.html#week-state-(type=week):value-sanitization-algorithm
      if (!isValidWeekString(val)) {
        val = "";
      }

  }

  return val;
};